module.exports = __webpack_public_path__ + "assets/img/zhuanjia.8ba8c9b9.png";